import { atomWithStorage } from "jotai/utils";

export const centerAcessAtom = atomWithStorage("centerAcess", false); // Initial value is false
